extendNative(Array.prototype, 'remove', function(item) {
  const ix = this.indexOf(item)
  if (ix > -1) {
    this.splice(ix, 1)
    return true
  }
  return false
})

extendNative(Element.prototype, 'closest', function(item) {
  if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
                                Element.prototype.webkitMatchesSelector
  }

  if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
      var el = this

      do {
        if (Element.prototype.matches.call(el, s)) return el
        el = el.parentElement || el.parentNode
      } while (el !== null && el.nodeType === 1)
      return null
    }
  }
})

function extendNative(prototype, name, fn) {
  if (prototype[name]) {
    return
  }
  prototype[name] = fn
}
